(function () {
  document.querySelectorAll(".klar-video-wall").forEach(function (section) {
    var grid = section.querySelector(".klar-video-wall__grid");
    if (!grid) return;

    var items = Array.from(grid.querySelectorAll(".klar-video-wall__item"));
    var videos = items.map(function (item) {
      return item.querySelector("video");
    });
    var currentIndex = -1;
    var prevBtn = section.querySelector(".klar-video-wall__nav--prev");
    var nextBtn = section.querySelector(".klar-video-wall__nav--next");

    function scrollToItem(item) {
      if (grid.scrollWidth > grid.clientWidth) {
        var itemLeft = item.offsetLeft - grid.offsetLeft;
        grid.scrollTo({ left: itemLeft, behavior: "smooth" });
      } else {
        item.scrollIntoView({ behavior: "smooth", block: "nearest" });
      }
    }

    function getStep() {
      var item = items[0];
      if (!item) return grid.clientWidth;
      var styles = window.getComputedStyle(grid);
      var gap = parseFloat(styles.columnGap || styles.gap) || 0;
      return item.getBoundingClientRect().width + gap;
    }

    function updateNav() {
      if (!prevBtn && !nextBtn) return;
      var maxScroll = grid.scrollWidth - grid.clientWidth;
      var canScroll = maxScroll > 2;
      var left = grid.scrollLeft;

      if (prevBtn) {
        prevBtn.hidden = !canScroll;
        prevBtn.disabled = left <= 2;
      }
      if (nextBtn) {
        nextBtn.hidden = !canScroll;
        nextBtn.disabled = left >= maxScroll - 2;
      }
    }

    function setPlaying(index, playing) {
      if (items[index]) items[index].classList.toggle("is-playing", playing);
    }

    function playAt(index) {
      if (currentIndex >= 0 && currentIndex !== index) {
        var prev = videos[currentIndex];
        if (prev) prev.pause();
        setPlaying(currentIndex, false);
      }

      currentIndex = index;
      var video = videos[currentIndex];
      if (!video) return;

      scrollToItem(items[currentIndex]);
      video.currentTime = 0;
      setPlaying(currentIndex, true);
      video.play().catch(function () {
        // Autoplay blocked by browser
        setPlaying(currentIndex, false);
      });
    }

    // Auto-advance when a video ends
    videos.forEach(function (video, i) {
      if (!video) return;
      video.addEventListener("ended", function () {
        setPlaying(i, false);
        var next = i + 1;
        if (next < items.length && videos[next]) {
          playAt(next);
        } else {
          currentIndex = -1;
        }
      });
    });

    // Click: play that video, or pause/resume if already active
    items.forEach(function (item, i) {
      item.addEventListener("click", function () {
        var video = videos[i];
        if (!video) return;
        if (currentIndex === i && !video.paused) {
          video.pause();
          setPlaying(i, false);
        } else {
          playAt(i);
        }
      });
    });

    if (prevBtn) {
      prevBtn.addEventListener("click", function () {
        grid.scrollBy({ left: -getStep(), behavior: "smooth" });
      });
    }

    if (nextBtn) {
      nextBtn.addEventListener("click", function () {
        grid.scrollBy({ left: getStep(), behavior: "smooth" });
      });
    }

    if (prevBtn || nextBtn) {
      grid.addEventListener("scroll", updateNav, { passive: true });
      window.addEventListener("resize", updateNav);
      requestAnimationFrame(updateNav);
    }
  });
})();
